module.exports = __webpack_public_path__ + "img/firma_template7.1338cb2.svg";